import { useSnackbar } from 'notistack';
import { useCallback, useState } from 'react';
import { editReviewStatus } from '../../../../crud/product.crud';
import { getResponseMessage } from '../../../../utils/utils';
import { useFormatMessage } from '../../../../hooks';

export const useChangeReviewStatus = (onSuccess?: () => void) => {
  const { enqueueSnackbar } = useSnackbar();
  const [statusLoading, setStatusLoading] = useState(false);
  const [err, setErr] = useState<any>(null);
  const [success, setSuccess] = useState(false);
  const fm = useFormatMessage();

  const changeReviewStatus = useCallback(
    async (review_id: number, status: string) => {
      setStatusLoading(true);
      editReviewStatus(review_id, status)
        .then(res => {
          setSuccess(true);
          onSuccess?.()
        })
        .catch(e => {
          enqueueSnackbar(`${fm('ERROR')}: ${getResponseMessage(e)}`, { variant: 'error' });
        })
        .finally(() => {
          setStatusLoading(false);
          setErr(null);
          setSuccess(false);
        });
    },
    []
  );

  return [changeReviewStatus, statusLoading, success, err];
};




